import { graphql } from "~/gql";
export const CREATE_TASK = graphql(/* GraphQL */ `
  mutation createAndAddTask($phaseId: Float!, $data: TaskCreateInput!) {
    createAndAddTask(phaseId: $phaseId, data: $data) {
      id
      title
      order
      html
      phaseId
      createdAt
      updatedAt
      markedComplete
    }
  }
`);

export const CREATE_TASKS = graphql(/* GraphQL */ `
  mutation createAndAddTasks($data: [TaskCreateInput!]!, $phaseId: Float!) {
    createAndAddTasks(data: $data, phaseId: $phaseId) {
      id
      title
      order
      html
      phaseId
      createdAt
      updatedAt
      markedComplete
    }
  }
`);
